const resource = `feedbacks`

export default function feedbacks({ apiClient }) {
  return {
    store(data) {
      return apiClient.post(resource, data)
    },
  }
}
